import React from 'react';
import PropTypes from 'prop-types';

import AdminPagination from '../Pagination';
import AdminResultsPerPageSelector from '../ResultsPerPageSelector';

const AdminUsersFooter = ({
  usersTotal,
  page,
  perPage,
  handleChangePage,
  handleChangePerPage,
}) => (
  <div className="table-footer">
    <AdminResultsPerPageSelector
      perPage={perPage}
      handleChangePerPage={handleChangePerPage}
    />
    <AdminPagination
      total={usersTotal}
      page={page}
      perPage={perPage}
      handleChangePage={handleChangePage}
    />
  </div>
);

AdminUsersFooter.propTypes = {
  usersTotal: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  handleChangePage: PropTypes.func.isRequired,
  handleChangePerPage: PropTypes.func.isRequired,
};

export default AdminUsersFooter;
